module.exports = __webpack_public_path__ + "img/ninjavan_charge_logo.5a881d45.png";